// src/components/BottomNavigation/ShopBottomNav.js
import React from 'react';
import styled from 'styled-components';
import { Home, Store, Users } from 'lucide-react';

const BottomNavContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 52px;
  background: ${props => `${props.theme?.colors?.background || '#000000'}F5`};
  backdrop-filter: blur(20px);
  border-top: 1px solid ${props => `${props.theme?.colors?.accent || '#800000'}30`};
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 1rem;
  z-index: 1000;
  
  /* Only show on mobile */
  @media (min-width: 769px) {
    display: none;
  }
`;

const NavButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: ${props => props.active ? 
    props.theme?.colors?.accent || '#800000' : 
    `${props.theme?.colors?.text || '#FFFFFF'}80`
  };
  cursor: pointer;
  padding: 0.22rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  position: relative;
  min-width: 70px;
  flex: 1;
  max-width: 120px;
  
  &:active {
    transform: scale(0.95);
  }
  
  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1px;
    position: relative;
  }
  
  .label {
    font-size: 8px;
    font-weight: 500;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    opacity: ${props => props.active ? 1 : 0.8};
  }
  
  /* Active state indicator */
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: ${props => props.active ? '4px' : '0'};
    height: 3px;
    background: ${props => props.theme?.colors?.accent || '#800000'};
    border-radius: 2px 2px 0 0;
    transition: width 0.3s ease;
  }
`;

const ShopBottomNav = ({ activeTab, onTabChange, theme }) => {
  const navigationItems = [
    {
      icon: <Home size={16} />,
      label: 'Home',
      tab: 'home'
    },
    {
      icon: <Store size={16} />,
      label: 'Shop',
      tab: 'shop'
    },
    {
      icon: <Users size={16} />,
      label: 'Profile',
      tab: 'profile'
    }
  ];

  return (
    <BottomNavContainer theme={theme}>
      {navigationItems.map((item) => (
        <NavButton
          key={item.tab}
          theme={theme}
          active={activeTab === item.tab}
          onClick={() => onTabChange(item.tab)}
        >
          <div className="icon-container">
            {item.icon}
          </div>
          <span className="label">{item.label}</span>
        </NavButton>
      ))}
    </BottomNavContainer>
  );
};

export default ShopBottomNav;